import React from "react";
import { Space, Form, InputNumber, Radio, Typography, RadioChangeEvent, FormInstance } from "antd";

import { useEditServiceContext } from "components/ratecard/contextProviders";
const { Text } = Typography;

type UnitsOption = "percentage" | "fixed";

const optionUnitsSymbolMap: Record<UnitsOption, string> = {
  percentage: "%",
  fixed: "$",
};

interface ConsumableMaterialFee {
  materialId: string;
  value: number;
  unit: string;
}

interface MarkupSectionProps {
  form: FormInstance;
}

const MarkupSection: React.FC<MarkupSectionProps> = ({ form }) => {
  const { allowEditing } = useEditServiceContext();
  const [value, setValue] = React.useState(0);
  const [units, setUnits] = React.useState<UnitsOption>("percentage");

  const supplies = form.getFieldValue("supplies") || [];

  const defaultConsumableMaterialFee = supplies.find((cmf: ConsumableMaterialFee) => cmf.materialId === "-1");

  if (defaultConsumableMaterialFee) {
    if (defaultConsumableMaterialFee.value !== value) {
      setValue(defaultConsumableMaterialFee.value);
    }
    if (defaultConsumableMaterialFee.unit !== units) {
      setUnits(defaultConsumableMaterialFee.unit);
    }
  }

  const updateFee = (value: number, unit: string) => {
    const supplies = form.getFieldValue("supplies") || [];

    const suppliesFiltered = supplies.filter((cmf: ConsumableMaterialFee) => cmf.materialId !== "-1");

    suppliesFiltered.push({
      materialId: "-1",
      value,
      unit,
    });

    form.setFieldsValue({
      supplies: suppliesFiltered,
    });
  };

  const onValueChange = (newValue: number) => {
    setValue(newValue);
    updateFee(newValue, units);
  };

  const onUnitsChange = (e: RadioChangeEvent) => {
    setUnits(e.target.value);
    updateFee(value, e.target.value);
  };

  return (
    <Space>
      <Form.Item name="supplies"></Form.Item>
      <Text strong>Default</Text>
      {units === "percentage" && (
        <InputNumber
          value={value}
          onChange={onValueChange}
          style={{ width: 100 }}
          disabled={!allowEditing}
          min={0}
          max={100}
        />
      )}
      {units === "fixed" && (
        <InputNumber
          value={value}
          onChange={onValueChange}
          style={{ width: 100 }}
          precision={2}
          step={0.1}
          disabled={!allowEditing}
          min={0}
        />
      )}
      <Radio.Group
        value={units}
        buttonStyle="solid"
        onChange={onUnitsChange}
        defaultValue={units}
        disabled={!allowEditing}
      >
        <Radio.Button value="percentage">{optionUnitsSymbolMap["percentage"]}</Radio.Button>
        <Radio.Button value="fixed">{optionUnitsSymbolMap["fixed"]}</Radio.Button>
      </Radio.Group>
    </Space>
  );
};

export default MarkupSection;
